import React from "react";
import styled from "styled-components";

import { Chip as ChipComponent } from "@ui-component-library";



const Chip = ({ type, label }) => {
  if (!type || type === "done" ) {
    return null;
  }

  const chipVariants = {
    unseen: {
      className: "bg-info-200 text-info-700",
      icon: "MailSimple",
      label: "Nytt"
    },
    seen: {
      className: "bg-pebble-200 text-pebble-900",
      icon: "CheckSimple",
      label: "Läst"
    },
    ongoing: {
      className: "bg-warning-200 text-warning-700",
      icon: "HourglassSimple",
      label: "Pågående"
    },
    beta: {
      className: "bg-info-200 text-info-800",
      icon: undefined,
      label: "Beta"
    },
    black: {
      className: "bg-charcoal-500 text-white-50",
      icon: undefined,
      label: label
    },
    plus: {
      className: "bg-primary-core text-black",
      icon: "SparkleFilled",
      label: "Plus"
    }
  };

  return <ChipComponent {...chipVariants[type]} />;
};

export { Chip };
